module.exports = __webpack_public_path__ + "img/amburger_no.75afa3ff.png";